import { fetchApi } from "../Utils/helper";
import { API_ENDPOINTS } from "../Constants/endpoints";

// Login 
export const loginService = async (payload) => {
  return await fetchApi({
    method: "POST",
    endPoint: API_ENDPOINTS.LOGIN,
    token: false,
    data: payload,
  });
};

// Logout
export const logoutService = async () => {
  return await fetchApi({
    method: "GET",
    endPoint: API_ENDPOINTS.LOGOUT,
    token: true,
  });
};

// Get All Users
export const getUsersService = async (page, perPage, search = "") => {
  try {
    const queryParams = new URLSearchParams();
    if (page) queryParams.append("page", page);
    if (perPage) queryParams.append("per_page", perPage);
    if (search?.trim()) {
      queryParams.append("search", search.trim());
    }

    const response = await fetchApi({
      method: "GET",
      endPoint: `${API_ENDPOINTS.GET_USERS}${queryParams.toString() ? `?${queryParams.toString()}` : ""}`,
      token: true,
    });
    
    return response;
  } catch (error) {
    console.error("getUsersService error", error);
    throw error;
  }
};

// Delete User
export const deleteUserService = async (userId) => {
  try {
    const response = await fetchApi({
      method: "DELETE",
      endPoint: API_ENDPOINTS.DELETE_USER(userId),
      token: true,
    });
    
    return response;
  } catch (error) {
    console.error("deleteUserService error", error);
    throw error;
  }
};

// Update User
export const updateUserService = async (userId, userData) => {
  try {
    const response = await fetchApi({
      method: "POST",
      endPoint: API_ENDPOINTS.UPDATE_USER(userId),
      data: userData,
      formData: true,
      token: true,
    });
    
    return response;
  } catch (error) {
    console.error("updateUserService error", error);
    throw error;
  }
};
